// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"294":"app-messages-en_US","586":"product-metadata"}[chunkId] + "." + {"294":"d651205d","586":"37f78bdf"}[chunkId] + ".chunk.js";
};